
import niceflixImg from "@/public/niceflix.png";
import reelsImg from "@/public/saddamreels.png";
import avatarImg from "@/public/avatar.jpg";


import { CgWorkAlt } from "react-icons/cg";
import { FaAws, FaReact, FaRaspberryPi } from "react-icons/fa";
import {
  RiCss3Line,
  RiDatabase2Line,
  RiGatsbyLine,
  RiGitBranchLine,
  RiHtml5Line,
  RiJavascriptLine,
  RiNextjsLine,
  RiNodejsLine,
  RiReactjsLine,
  RiTailwindCssLine,
} from "react-icons/ri";
import {
  TbBrandFramerMotion,
  TbBrandGraphql,
  TbBrandMongodb,
  TbBrandNodejs,
  TbBrandPython,
  TbBrandReactNative,
  TbBrandRedux,
  TbBrandSocketIo,
  TbBrandTypescript,
} from "react-icons/tb";

import React from "react";

const experienceInYears = new Date().getFullYear() - 2020;

export const profile = {
  avatar: avatarImg,
  email: "saddamhu.dev@gmail.com",
  whatsapp: "+923064502564",
  name: "Saddam Hussain",
  title: "Full Stack Software Engineer",
  experience: `${experienceInYears} years`,
  likes: "building web and mobile apps",
  resumeLink: `https://drive.google.com/uc?export=download&id=1O5Vy-mO-DlffMXmO88481mE4VDAl7oHq`,
  linkedInLink: "https://www.linkedin.com/in/saddam-hussain-3719b2248/",
  githubLink: "https://github.com/saddam008h",
  domain: "https://saddamdev.com",
  alternateName: "Saddam",
  description: "Full Stack Software Engineer with 5+ years of experience specializing in React, Next.js, Node.js, TypeScript, and AWS. Expert in building scalable web and mobile applications.",
} as const;

export const currentCompany = {
  name: "FuseAI (YC-W25)",
  url: "https://www.tryfuse.ai/",
  logo: "/fuseai.jpeg",
} as const;

export const companies = [
  {
    name: "Dekki AI",
    url: "https://www.dekki.ai/",
    logo: "/dekki.jpeg",
  },
  {
    name: "Amanahfy",
    url: "https://www.amanahfy.com/",
    logo: "/amanahfy.jpeg",
  },
  {
    name: "Quick Sync",
    url: "https://info.quicksync.me/  ",
    logo: "/quicksync.png",
  },
  {
    name: "Mentoria Pakistan",
    url: "https://mentoriapk.vercel.app/",
    logo: "/mentlogo.jpeg",
  }
] as const;

export const links = [
  {
    name: "Home",
    hash: "#home",
  },
  {
    name: "About",
    hash: "#about",
  },
  {
    name: "Experience",
    hash: "#experience",
  },
  {
    name: "Projects",
    hash: "#projects",
  },
  {
    name: "Skills",
    hash: "#skills",
  },
  {
    name: "Resume",
    hash: "#resume",
  },
  {
    name: "Contact",
    hash: "#contact",
  },
] as const;

export const experiencesData = [
  {
    title: "Full Stack Developer",
    company: "FuseAI (YC-W25)",
    location: "New York (Remote)",
    description:
      "Working as Full Time Software Engineer at FuseAI. Building scalable, high-performance applications and chrome extensions leveraging cloud services and modern frameworks.",
    icon: React.createElement(FaReact),
    date: "Aug 2024 - Present",
  },
  {
    title: "Software Developer",
    company: "QuickSync",
    location: "Germany (Remote)",
    description:
      "Worked on blockchain-based real-time data synchronization infrastructure, enabling secure and decentralized collaboration with efficient state management across clients.",
    icon: React.createElement(CgWorkAlt),
    date: "Oct 2023 - Sep 2024",
  },
  {
    title: "Full Stack MERN Developer",
    company: "Amanahfy",
    location: "London (Remote)",
    description:
      "Worked on developing full stack web applications with a large team, delivering production-ready solutions using the MERN ecosystem.",
    icon: React.createElement(CgWorkAlt),
    date: "Feb 2024 - Sep 2024",
  },
  {
    title: "Full Stack Web Developer",
    company: "Dekki AI",
    location: "Pakistan",
    description:
      "Collaborated with the web development team, gaining experience with modern methodologies and processes. Utilized latest technologies including MERN Stack, Next.js, and AWS.",
    icon: React.createElement(CgWorkAlt),
    date: "Jun 2023 - Sep 2023",
  },
  {
    title: "Co-founder & CTO",
    company: "Mentoria Pakistan",
    location: "Pakistan",
    description:
      "Led technical development as Co-founder and CTO. Developed and maintained company website using TypeScript and Next.js, establishing the technical foundation and architecture.",
    icon: React.createElement(FaReact),
    date: "Mar 2021 - Sep 2022",
  },
] as const;

export const projectsData = [
  {
    title: "NiceFlix",
    description:
      "Search shows, movies and artists dynamically. Complete details of movies, shows andartists. Watch trailers and similar videos suggestions. add to watch later and add to like collections.",
    tags: ["React", "NodeJS", "MongoDB", "DesyUI", "TailwindCSS", "Vercel"],
    imageUrl: niceflixImg,
    url: "http://nice-flix.vercel.app",
    githubUrl: "https://github.com/saddam008h/NiceFlix",
  },
  {
    title: "Saddam Reels",
    description:
      "Saddam Reels is a full stack NextJS app with popular backend platform app-write. It has login, edit profile, upload reels, comments and dynamic search features.",
    tags: ["NextJS", "Supabase", "App-write cloud", "auth"],
    imageUrl: reelsImg,
    url: "https://saddamreels.vercel.app/",
    githubUrl: "https://github.com/saddam008h/saddam-reels",
  },
] as const;

export const skillsData = [
  { name: "HTML", icon: RiHtml5Line },
  { name: "CSS", icon: RiCss3Line },
  { name: "JavaScript", icon: RiJavascriptLine },
  { name: "TypeScript", icon: TbBrandTypescript },
  { name: "React", icon: RiReactjsLine },
  { name: "Next.js", icon: RiNextjsLine },
  { name: "NodeJS", icon: RiNodejsLine },
  { name: "React Native", icon: TbBrandReactNative },
  { name: "Framer Motion", icon: TbBrandFramerMotion },
  { name: "Git", icon: RiGitBranchLine },
  { name: "Tailwind", icon: RiTailwindCssLine },
  { name: "MongoDB", icon: TbBrandMongodb },
  { name: "Redux", icon: TbBrandRedux },
  { name: "Gatsby", icon: RiGatsbyLine },
  { name: "GraphQL", icon: TbBrandGraphql },
  { name: "Express", icon: TbBrandNodejs },
  { name: "Socket IO", icon: TbBrandSocketIo },
  { name: "PostgreSQL", icon: RiDatabase2Line },
  { name: "Python", icon: TbBrandPython },
  { name: "Flask", icon: TbBrandPython },
  { name: "FastAPI", icon: TbBrandPython },
  { name: "AWS", icon: FaAws },
  { name: "Raspberry Pi", icon: FaRaspberryPi },
  { name: "...and more", icon: React.Fragment },
] as const;
